import * as React from "react";
import * as styles from "./NotFound.scss";

export const NotFound = () => {
  return <h1 className={styles.title}>NotFound</h1>;
};
